const map = {
	"./Logo/logo.png": 86683,
	"./Logo/logo1.png": 71050,
	"./Logo/logo2.png": 20033,
	"./attach.svg": 33391,
	"./background.png": 38460,
	"./badge96.png": 62390,
	"./block-cmt.svg": 49908,
	"./block-direct.svg": 20199,
	"./broken_image.png": 31245,
	"./chotot.png": 14801,
	"./comment (1).svg": 1677,
	"./comment.svg": 29311,
	"./edit.svg": 89188,
	"./fb.svg": 8560,
	"./hide.svg": 30560,
	"./icon-chat.svg": 21758,
	"./ignasi_pattern_s.png": 61638,
	"./insta.svg": 49793,
	"./logo.jpg": 52717,
	"./logo.png": 62077,
	"./logo.svg": 67717,
	"./logo1.png": 32480,
	"./logo192.png": 3273,
	"./logo32x32.png": 49463,
	"./logo32x32a.png": 58750,
	"./logo96.png": 29420,
	"./logout.svg": 91378,
	"./menu/Auto comment.png": 30240,
	"./menu/Autoinbox.png": 35583,
	"./menu/BitChat.png": 85895,
	"./menu/Brandname.png": 34330,
	"./menu/CallCenter.png": 82325,
	"./menu/Edit.png": 22378,
	"./menu/Fanpage.png": 90754,
	"./menu/LiveChat.png": 69162,
	"./menu/LiveStream.png": 76700,
	"./menu/Logout.png": 6280,
	"./menu/Seeding.png": 62993,
	"./menu/Smile.png": 60344,
	"./menu/SpamComment.png": 25170,
	"./menu/StaffRoleChat.png": 19864,
	"./menu/ZaloOA.png": 67938,
	"./menu/booking.png": 27473,
	"./menu/icon/AutoTarget.png": 33520,
	"./menu/icon/Khamsangloc.png": 55364,
	"./menu/icon/Laymautestnhanh.png": 72742,
	"./menu/icon/Thuphitestnhanh.png": 22515,
	"./menu/icon/Traketquatestnhanh.png": 50251,
	"./menu/icon/autocmt.png": 58651,
	"./menu/icon/autoinbox.png": 62883,
	"./menu/icon/autopostfb.png": 76557,
	"./menu/icon/autoreply.png": 27047,
	"./menu/icon/bitchat.png": 95523,
	"./menu/icon/bitlivechat.png": 52157,
	"./menu/icon/callcenter.png": 73465,
	"./menu/icon/chat.png": 10172,
	"./menu/icon/chinhanh.png": 25445,
	"./menu/icon/companyjoin.png": 36505,
	"./menu/icon/fanpage.png": 12094,
	"./menu/icon/feedback1.png": 50754,
	"./menu/icon/khaosat.png": 99707,
	"./menu/icon/lichhen.png": 42333,
	"./menu/icon/lichtruc.png": 28212,
	"./menu/icon/livestream.png": 44512,
	"./menu/icon/logout.png": 22524,
	"./menu/icon/nhanvien.png": 38135,
	"./menu/icon/sanpham.png": 89884,
	"./menu/icon/seeding.png": 74213,
	"./menu/icon/smsbrandname.png": 20909,
	"./menu/icon/thongke.png": 98954,
	"./menu/icon/user.png": 38107,
	"./menu/icon/usergroups.png": 19363,
	"./menu/icon/zalo.webp": 40806,
	"./menu/icon/zalooa.png": 42558,
	"./menu/new_icons/icon-ai.png": 29126,
	"./menu/new_icons/icon-branch.png": 12620,
	"./menu/new_icons/icon-chat-new.png": 21991,
	"./menu/new_icons/icon-chat.png": 83162,
	"./menu/new_icons/icon-customer.png": 80912,
	"./menu/new_icons/icon-employee.png": 90768,
	"./menu/new_icons/icon-fanpage.png": 17136,
	"./menu/new_icons/icon-join-branch.png": 91535,
	"./menu/new_icons/icon-logout.png": 57154,
	"./menu/new_icons/icon-post.png": 79326,
	"./menu/new_icons/icon-product.png": 88935,
	"./menu/new_icons/icon-profile.png": 91585,
	"./menu/new_icons/icon-sms.png": 60245,
	"./menu/new_icons/icon-statistic.png": 24668,
	"./menu/new_icons/icon-telegram.png": 44737,
	"./menu/new_icons/icon-telegram_1.png": 14769,
	"./menu/new_icons/icon-users-manager.png": 67984,
	"./menu/new_icons/icon-webchat.png": 26870,
	"./menu/new_icons/icon-whatapps.png": 21570,
	"./menu/new_icons/icon-zalo.png": 68500,
	"./menu/setting.png": 24812,
	"./menu/staff.png": 77610,
	"./menu/user.png": 3975,
	"./no_images.png": 76196,
	"./og-logo.jpeg": 769,
	"./refresh.svg": 12713,
	"./shopee.png": 95242,
	"./trash.svg": 97286,
	"./undraw_empty.svg": 31549,
	"./user.jpg": 18453,
	"./vchat.ico": 17565,
	"./zalo.png": 42028,
	"./zalo.webp": 70168
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87958;